export default {
  currency: {
    fullVersionNo: '完整版本号：{version}',
    fullVersionLabel: '完整版本号',
    currentVersion: '当前版本 {version} · {currency}',
    addCurrency: '新增币种',
    maintainRates: '维护并发布新汇率',
    code: '代码',
    chineseName: '中文名',
    englishName: '英文名',
    symbol: '符号',
    cnyRateTitle: '1 单位币种 = CNY',
    pendingMaintenance: '待维护',
    enabled: '启用',
    disabled: '停用',
    baseCurrency: '基础币',
    rateHistory: '汇率版本历史',
    rateDetailTitle: '{displayVersion}（{version}）汇率明细（1 单位币种 = N CNY）',
    currency: '币种',
    cnyRate: '兑人民币汇率',
    baseRate: '兑该版本基础币',
    shortVersionNo: '短版本号',
    baseSettlementCurrency: '基础结算币种',
    rateSummary: '汇率摘要',
    currentVersionColumn: '当前版本',
    publishedAt: '发布时间',
    viewRates: '查看汇率',
    editCurrency: '编辑币种',
    currencyCode: '币种代码',
    currencySymbol: '货币符号',
    decimalPlaces: '金额小数位',
    sortOrder: '排序',
    publishHint: '汇率方向统一为：1 单位币种等于多少人民币（CNY）。发布后旧版本保留且不可修改。',
    publishNewVersion: '发布新版本',
    historicalDetail: '历史汇率版本详情',
    baseCurrencyRate: '兑基础币汇率',
    noRateDetail: '无汇率明细',
    fillRequired: '请填写必填项',
    fillValidRate: '请填写 {code} 的有效汇率',
    publishConfirm: '发布后将成为新业务和锁定结算使用的当前汇率，是否继续？',
    confirmPublish: '确认发布',
    published: '新汇率版本已发布',
    rateVersionLabel: '{source}/{target} {rate}｜版本 {version}',
    convertedTooltipLabel: '≈{converted}（{source}/{target} {rate}｜版本 {version}）',
  },
  palletType: {
    saveAirlineConfig: '保存当前航司配置',
    copyFromAirline: '从其他航司复制',
    selectInitSource: '选择初始化来源',
    copyAll: '复制整套配置',
    selectAirlineHint: '请先选择签发航司，再维护该航司专属的板型配置。',
    deleteHint: '删除后保存时：已被协议或产品委托使用的板型将转为未启用；未被使用的板型将直接删除。',
    typeCode: '板位类型编号',
    chargeWeightKg: '计费重（KG）',
    maxGrossWeightKg: '可装载毛重（KG）',
    maxVolumeCbm: '可装载立方数（CBM）',
    addType: '+ 新增板型',
    unnamed: '（未命名）',
    deleteConfirm: '确定删除板型 {code}？保存时，已使用的数据会自动转为未启用。',
    sourceEmpty: '来源航司尚未配置板型',
    copyConfirm: '复制会替换当前界面尚未保存的数据，是否继续？',
    copied: '已复制到当前界面，请检查或修改后保存',
    codeRequired: '板型编号不能为空',
    codeDuplicate: '板型编号不能重复',
    saved: '板型配置保存成功',
    savedWithDisabled: '板型配置保存成功；已使用的删除项已自动转为未启用',
  },
  mawbPool: {
    overviewTitle: '库存看板',
    overviewEmpty: '号池暂无数据，请先导入号段',
    freeCount: '空闲',
    reservedCount: '预占中',
    usedCount: '已使用',
    voidCount: '已作废',
    totalCount: '总量',
    availableCount: '可分配',
    lowStock: '低库存',
    importTitle: '号段导入',
    importHint: '选择航司并输入连续流水号区间（7位，含两端），第11位校验位由系统按流水号 mod 7 自动计算，逐号校验冲突，任一冲突则整段拒收。',
    startSerial: '起始流水号',
    endSerial: '终止流水号',
    receivedDate: '领用日期',
    importBtn: '导入号段',
    previewSummary: '本次将导入 {count} 个号码：{first} ~ {last}（校验位自动计算）',
    previewPrefixMissing: '该航司尚未配置数字前缀，请先在“航司前缀”页签维护后再导入',
    importSuccess: '号段导入成功：{count} 个号码，批次号 {batchNo}',
    importReused: '其中复用号 {count} 个',
    excelImportTitle: 'Excel导入',
    excelImportHint: '下载模板后按格式填写（每行一个号码：航司代码、主单号、备注），航司须与上方所选一致且一份Excel仅支持一个航司，任一冲突整份拒收。',
    downloadTemplateBtn: '下载导入模板',
    excelImportBtn: '导入Excel',
    excelNoFile: '请先选择Excel文件',
    excelFileType: '仅支持 .xlsx / .xls 文件',
    selectFile: '选择文件',
    excelImportSuccess: 'Excel导入成功：{count} 个号码，批次号 {batchNo}',
    excelImportRejected: 'Excel导入被拒（整份拒收）',
    prefixAutoConfigured: '航司 {airline} 的数字前缀 {prefix} 已自动记忆',
    importRejected: '号段导入被拒（整段拒收）',
    conflictMawbNo: '主单号',
    conflictReason: '冲突原因',
    conflictBatchNo: '冲突批次',
    conflictStatus: '冲突状态',
    conflictLastUsedAt: '上次使用',
    conflictProductOrderNo: '占用产品委托号',
    batchesTab: '号码申领',
    numbersTab: '号码查询',
    prefixesTab: '航司前缀',
    batchNo: '批次号',
    airline: '航司',
    noPrefix: '未配置前缀',
    batchDetailTitle: '批次 {batchNo} 号码明细',
    numericPrefix: '数字前缀（3位）',
    segment: '号段（起~止）',
    quantity: '号码数',
    sourceType: '来源',
    sourceMANUAL: '手工导入',
    sourceEXCEL: 'Excel导入',
    sourceLEGACY: '存量迁移',
    sourceSINGLE: '单个填写',
    freeCountShort: '空闲',
    reservedCountShort: '预占',
    usedCountShort: '已用',
    voidCountShort: '作废',
    importedAt: '导入时间',
    mawbNo: '主单号',
    status: '状态',
    statusFREE: '空闲',
    statusRESERVED: '预占中',
    statusUSED: '已使用',
    statusVOID: '已作废',
    productOrderNo: '绑定产品委托号',
    lastUsedAt: '上次使用',
    batchColumn: '批次',
    viewLogs: '操作记录',
    logsTitle: '号码流水：{mawbNo}',
    action: '动作',
    actionIMPORT: '导入',
    actionRESERVE: '预占',
    actionRELEASE: '释放',
    actionUSE: '使用',
    actionVOID: '作废',
    operatedAt: '操作时间',
    operator: '操作人',
    fromToStatus: '状态变化',
    voidBtn: '作废',
    voidConfirm: '确定作废主单号 {mawbNo}？作废后号码不可回池、不可再分配。',
    voidSuccess: '号码已作废',
    addPrefix: '新增前缀',
    prefixSaved: '航司前缀已保存',
    prefixExists: '该航司已配置前缀',
    prefixDigits: '前缀须为 3 位数字',
    selectAirlineFirst: '请先选择航司',
    startSerialRequired: '请输入起始流水号',
    endSerialRequired: '请输入终止流水号',
    rangeInvalid: '起始流水号必须不大于终止流水号',
    rangeTooLarge: '单次导入号段不能超过 {max} 个号码',
    serialNoFormat: '流水号须为 7 位纯数字',
    allAirlines: '全部航司',
    allStatuses: '全部状态',
    dateFrom: '使用时间从',
    dateTo: '至',
    noData: '暂无数据',
    revokeBtn: '撤销',
    revokeSuccess: '主单号已撤销，号码已回池',
    select: {
      title: '从号池选取主单号',
      tabManual: '手动挑选',
      tabSegment: '号段连续',
      tabAuto: '自动分配',
      tabSingle: '单个填写',
      singleHint: '前 3 位为航司数字前缀（自动回显，无需填写），仅需填写后 8 位（7 位流水号 + 1 位校验位）；系统将校验前缀、校验位及号池冲突（含复用窗口），通过后自动生成单号批次并领用到当前产品委托号',
      prefixRequired: '请填写 3 位航司数字前缀',
      serial8Required: '主单号后 8 位须为 8 位纯数字（7 位流水号 + 1 位校验位）',
      receivedDateRequired: '请选择领用日期',
      manualHint: '从可用号列表中勾选号码，单次最多 20 个',
      segmentHint: '选择批次并输入起始号与数量，系统将校验号段连续可用性',
      autoHint: '按批次导入时间与号码顺序（先进先出）自动分配',
      batchFilter: '批次（可选）',
      maxCountHint: '单次最多 {max} 个',
      selectedCount: '已选 {count} 个',
      batchRequired: '请选择批次',
      countRequired: '请输入数量',
      countMax: '单次最多 {max} 个',
      previewBtn: '预览',
      previewEmpty: '请先填写取号条件',
      availableTrue: '可分配',
      previewUnavailable: '不可分配',
      confirmBtn: '确认取号',
      created: '成功创建 {count} 个主单号区域',
      noAvailable: '该航司暂无可用号码，请先导入号段',
    },
  },
  agreement: {
    searchAirline: '航司代码/名称',
    searchRoute: '航线/港口',
    periodStart: '协议周期开始',
    periodEnd: '协议周期结束',
    creator: '创建人',
    createdStart: '创建日期开始',
    createdEnd: '创建日期结束',
    chargeWeightLine: '计费重：{weight} KG（{count}板）',
    chargeWeightOnly: '计费重：{weight} KG',
    grossWeightLine: '毛重：{weight} KG',
    volumeLine: '立方：{volume} CBM',
    bsaPrice: '包板单价',
    volumePrice: '包量单价',
    execution: '协议执行情况',
    overviewAndPeriods: '总览与分周期执行情况',
    allPeriods: '全部周期',
    searchPeriod: '查询周期编号或日期',
    overview: '总览',
    overallExecution: '协议整体执行情况',
    relatedProductOrders: '关联产品委托号',
    executionEq: '协议执行、履约与 EQ CW',
    noExecutionData: '暂无协议执行数据',
    relatedAgreementOrders: '关联协议委托号',
    noRelatedAgreementOrders: '暂无关联的协议委托号',
    validity: '有效期',
    validityStatus: '生效状态',
    deleteWithChildren: '确认删除协议“{no}”吗？其下 {count} 个尚未被产品委托使用的协议委托号也会一并删除。',
    deactivateAction: '失效',
    activateAction: '生效',
    deactivateImpact: '失效后，新建或编辑产品委托号时将不能再选择这些协议委托号；已有绑定不受影响。',
    activateImpact: '生效后，其下协议委托号将重新成为可选项。',
    statusConfirm: '确认{action}协议“{no}”吗？此操作将批量{action}其下 {count} 个协议委托号。{impact}',
    statusTitle: '{action}协议',
    statusConfirmButton: '确认{action}',
    statusChanged: '协议及其相关协议委托号已{action}',
    statusFailed: '{action}失败',
    periodStatusOngoing: '进行中',
    periodStatusEnded: '已结束',
    selectAgreementNo: '请选择协议编号',
    agreementDetail: '协议详情',
    autoNo: '选择协议编号后自动生成',
    autoFill: '选择协议编号后自动回显',
    eqPeriod: 'EQ周期',
    selectAirlineFirst: '请先确定航司',
    palletCount: '板数',
    perPalletCharge: '计费 {value} KG/板',
    perPalletGross: '毛重 {value} KG/板',
    perPalletVolume: '立方 {value} CBM/板',
    chargeTotal: '计费重量合计',
    chargeTotalWithCount: '{value} KG（{count}板）',
    grossTotal: '可装载毛重合计',
    volumeTotal: '可装载立方合计',
    grossPerPallet: '毛重/板(KG)',
    volumePerPallet: '立方/板(CBM)',
    detailTitle: '协议详情 - {no}',
    airline: '航司',
    period: '协议周期',
    active: '生效',
    inactive: '未生效',
    terms: '协议条款',
    noTerms: '暂无协议条款内容',
    transitPortPattern: '中转港请输入3位港口代码',
    selectAgreementType: '请选择协议类型',
  },
  eq: {
    title: 'EQ 结算计费重',
    dynamicHint: 'EQ 值为当前视角，协议未结束前会随业务变动（新产品委托加入、货物承接、入仓回填）而变化',
    statusActive: '进行中',
    statusEndedManual: '已关账 · 手动',
    statusEndedAuto: '已关账 · 自动',
    current: '当前应结算',
    currentHintBsa: 'GW 累计 / 切片板重 / 实际板重 三值取最大',
    currentHintVolume: 'GW 累计 / 切片包量 / 货物计费重 三值取最大',
    projected: '最终完成所需',
    final: 'Final',
    finalPreview: '未固化（预览）',
    finalFixed: '固化值',
    finalPreviewCaption: '关账后固化，当前展示为最终完成所需预览',
    finalizedAt: '固化时间',
    finalizedBy: '操作人',
    closedReason: '关账原因',
    remainingTitle: '剩余量',
    progressLabel: '已执行 / 最终所需',
    remainingFormula: '剩余 = 最终所需 − 当前应结算口径',
    overrun: '超出 {weight} KG',
    remainingLabel: '剩余 {weight} KG',
    componentsTitle: '构成明细',
    gwTotal: '累计毛重 GW',
    dueQuota: '切片{quotaType}（进度 {progress}%）',
    usedPallet: '实际使用板重',
    agreedPallet: '合同板重',
    agreedVolume: '包量约定重量',
    cargoChargeable: '货物计费重',
    periodProgress: '周期进度',
    quotaTypePallet: '板重',
    quotaTypeVolume: '包量',
    closeBtn: '关账',
    reopenBtn: '撤销关账',
    closeConfirmTitle: '关账确认',
    closeInPeriodTitle: '关账确认（协议尚在周期内）',
    closeInPeriodMsg: '该协议委托尚在周期内（结束日 {endDate}，剩余 {days} 天）。关账后 Final 应结算计费重（{value} KG）将立即固化，之后业务数据变化不再影响 EQ 结算口径。确认关账？',
    closePassedMsg: '协议委托已过结束日，确认关账固化 Final 应结算计费重（{value} KG）？',
    closeNoEndDateMsg: '该协议委托未设置结束日。关账后 Final 应结算计费重（{value} KG）将立即固化，之后业务数据变化不再影响 EQ 结算口径。确认关账？',
    confirmClose: '确认关账',
    reopenConfirmTitle: '撤销关账确认',
    reopenConfirmMsg: '撤销后恢复为进行中，Final 固化值将清除，EQ 恢复按动态口径计算。确认撤销？',
    closeSuccess: '关账成功，Final 应结算计费重已固化',
    reopenSuccess: '已撤销关账，EQ 恢复动态口径',
    loadFailed: 'EQ 结算数据加载失败',
    // EQ 成本分摊（EQ 阶段 3：协议池 → 产品委托，吃泡偏离值内核）
    eqAllocationTitle: 'EQ 成本分摊（协议池）',
    poolTotalCost: '池总成本',
    totalIndependentCost: '独立成本合计',
    totalSaving: '节省（EQ 收益）',
    totalCustomerCw: 'Customer CW 合计',
    colProductOrderNo: '产品委托号',
    colMawbCount: '主单数',
    colCustomerCw: 'Customer CW (KG)',
    colAvgRate: '均价',
    colIndependentCost: '独立成本',
    colDeviation: '偏离值',
    colEqAllocatedCost: 'EQ 分摊成本',
    colEqEffectiveRate: 'EQ 有效单价',
    colStdCwTotal: '标准计费重(总)',
    heavyCargo: '重货',
    bubbleCargo: '泡货',
    eqMemberCount: '{count} 个成员产品委托',
    eqCostLoadFailed: 'EQ 成本分摊数据加载失败',
    eqEmptyPool: '暂无成员产品委托（需满足：有主单、Customer CW > 0、均价可算）',
    eqTotalRow: '合计',
  },
  execution: {
    agreed: '① 协议约定',
    operation: '② 实际操作',
    cargo: '{index} 实际执行货物',
    uldType: '板型',
    palletCount: '板位数',
    palletUnit: '板',
    volumeChargeWeight: '包量计费重',
    totalPalletWeight: 'Total 板重',
    totalGross: 'Total 可装载毛重',
    totalVolume: 'Total 极限装载立方',
    relatedAgreementCount: '关联协议委托',
    relatedProductCount: '关联产品委托',
    countUnit: '个',
    cargoGross: '累计毛重 GW',
    cargoVolume: '累计立方 VOL',
    cargoChargeWeight: '累计计费重',
    volumetricWeight: '立方换算体积重',
    agreedPlain: '协议约定',
    actualExecution: '实际执行',
    cumulativeGross: '累计毛重',
    cumulativeVolume: '累计立方',
    cumulativeProductCw: '累计产品计费重',
    executionCw: '执行计费重',
    productCwTotal: '各产品自身 CW 合计',
    agreementMergedCw: '协议合并计费重',
    performance: '达标情况',
    completed: '履约完成',
    notCompleted: '未达标',
    volumePerformanceFormula: '协议合并计费重 {reference} KG；合同包量计费重 {agreed} KG',
    bsaPerformanceFormula: 'max（实际毛重 {gross} KG，实际使用总板位板重 {operation} KG）= {reference} KG；合同总板重 {agreed} KG',
    completedHint: '已达到协议约定，应付总计费重按协议级汇总口径计算。',
    shortfall: '需补重量 {weight} KG。',
    shortfallPrice: '按本协议实际有出货航线中的最高单价 {currency} {price}/KG 计价，补差金额 {currency} {amount}。',
    noShortfallPrice: '当前尚无可用于补差计价的实际出货航线单价。',
    agreementCw: '协议总计费重',
    agreementCwHint: '跨产品合并后，GW 与体积重取大值',
    payableCw: '应付总计费重',
    payableVolumeHint: '合同包量与协议计费重取大值',
    payableBsaHint: '合同板重、实际毛重、实际使用板重取大值',
    lossCapacity: '亏舱量',
    lossHint: '应付总计费重 − 实际毛重',
    agreedDifference: '约定差额',
    differenceHint: '负数红字为未达，正数绿字为超出',
    productEqTitle: '关联产品委托号及协议级 EQ CW',
    productEqHint: 'EQ CW 按当前 ETD 查询结果中各产品自身计费重占比进行分摊，展示尾差已平衡',
    startDate: '开始日期',
    endDate: '结束日期',
    completedStats: '已完成产品委托累计',
    allStats: '全部产品委托累计（进行中 + 已完成）',
    ticketUnit: '票',
    noRelatedProducts: '暂无关联的产品委托号',
    ownCw: '自身计费重 CW',
    agreementEqCw: '协议均衡 EQ CW',
    cwShare: 'CW 占比',
    trunkRate: '干线单价',
    inProgress: '进行中',
  },
  productRecord: {
    palletInfo: '板位信息',
    pallets: '板数',
    chargePerPallet: '计费重/板(KG)',
    reservedWeight: '预占重量(KG)',
    usedWeight: '已用重量(KG)',
    grossPerPallet: '可装毛重/板(KG)',
    volumePerPallet: '可装体积/板(CBM)',
    pricingCurrency: '计价币种',
    settlementCurrency: '结算币种（默认币种）',
    cargoSettlementSummary: '货物与航司结算汇总',
    settlementFormula: '干线计费重 = Σ各主单号航线计费重',
    grossTotal: '累计毛重 GW',
    customerCwTotal: '累计客户计费重 CW',
    volumeTotal: '累计体积 VOL',
    volumetricWeight: '合并体积重',
    reservedPalletWeight: '预占板位重量',
    settlementCw: '干线计费重',
    trunkRate: '干线单价',
    settlementAmount: '航司结算计费重金额',
    cwDifference: '合并计费重差额',
    volumetricWeightFormula: '合并体积重 = 累计体积 ÷ 0.006',
    airlineSettlementAmountFormula: '航司结算计费重金额 = 干线计费重 × 干线单价',
    cwDifferenceFormula: '合并计费重差额 = 累计客户计费重 − 干线计费重',
    eqCwFormula: '均衡计费重 EQ CW = 干线计费重 × 客户计费重占比（显示 2 位小数，尾差按最大余数法分配）',
    customerCwFormula: '客户计费重 = Σ各业务委托客户计费重（分泡按计费重体现时取分泡后计费重）',
    cargoEqTitle: '业务委托货物及 EQ CW 分摊',
    piecesUnit: '件',
    grossGw: '毛重 GW',
    volumeVol: '体积 VOL',
    customerCw: '客户计费重 CW',
    afterBubble: '分泡后',
    cwShare: 'CW 占比',
    eqCw: '均衡计费重 EQ CW',
    weightDifference: '重量差额 CW − EQ CW',
    noCargo: '暂无关联业务委托货物',
    mawbHawbList: '主分单清单',
    loadSummaryFailed: '加载产品委托货物汇总失败',
  },
  // entry/dialogs/InfoOverviewModal 信息纵览
  infoOverview: {
    warehouseCompareTitle: '已进仓 / 未进仓汇总比对',
    bizOrderTotal: '业务委托总数',
    enteredOrders: '已进仓',
    notEnteredOrders: '未进仓',
    enteredProgress: '进仓进度',
    warehouseStatus: '入仓状态',
    booked: '预计',
    actual: '实际',
    actualDiff: '差异(实际−预计)',
    piecesMetric: '件数',
    expandHint: '点击行首箭头可展开/折叠货物件尺寸明细',
    pieceDimsTitle: '货物件尺寸明细',
    noPieceDims: '暂无件尺寸数据',
    piecesSum: '件数合计',
    volumeSum: '体积合计',
    loadFailed: '加载信息纵览数据失败',
    unitOrders: '单',
    exportCargoEq: '导出 Excel',
    exportFailed: '导出失败，请重试',
    exportSubtitle: '产品委托号：{orderNo}｜航班：{flight}｜航线：{route}｜ETD：{etd}',
    exportDimLabel: '└ 件尺寸 {no}',
    exportDimsTotal: '└ 件尺寸合计',
    exportBubbleNote: '注：{orders} 的客户计费重为泡重后计费重',
  },
  dashboard: {
    period: '经营统计周期',
    month: '本月',
    quarter: '本季度',
    year: '本年度',
    bizOrderCount: '业务委托数',
    addedToday: '{period} · 今日新增 {count}',
    cwTotal: '{period}累计计费重',
    profitTotal: '累计毛利 ¥{amount}',
    marginFormula: '毛利 ÷ 收入',
    product: '产品:',
    business: '业务:',
    trend: '业务量与毛利趋势（{period}）',
    airlineDistribution: '航司货量分布（{period}）',
    bizOrders: '业务委托: {count}',
    profit: '毛利: {amount}',
  },
  productOrder: {
    selectAirlineFirst: '请先确定航司',
    selectEtdFirst: '请先填写ETD，再选择协议委托号（按ETD判断协议有效期）',
    palletCount: '板数',
    palletUnit: '板',
    charge: '计费',
    gross: '毛重',
    volume: '立方',
    chargeTotal: '计费重量合计',
    grossTotal: '可装载毛重合计',
    volumeTotal: '可装载立方合计',
    agreementSuffix: '{type}-协议',
    kgPerPallet: 'KG/板',
    maxGross: '可装载毛重',
    maxVolume: '可装载立方',
    cbmPerPallet: 'CBM/板',
    capacityDescription: '，可装载毛重 {gross} KG/板，可装载立方 {volume} CBM/板',
    actualOperationPallet: '实际操作板型',
    actualCargo: '实际执行货物',
    noRelated: '暂无关联产品委托号',
  },
  workbench: {
    customerEntered: '客服已录入',
    cancellationTitle: '业务委托撤单申请',
    cancellationMessage: '{no}业务委托号申请撤单，本产品委托号{productNo} 将空出舱位{weight} KG',
    later: '稍后再说',
    reject: '拒绝',
    accept: '接受',
    accepted: '已接受撤单申请',
    rejected: '已拒绝撤单申请',
    cancellationFailed: '处理撤单申请失败',
    rejectedMessage: '{no}业务委托号申请撤单被拒绝，您可联系航线人员：{operator} 协商。',
    rejectedTitle: '撤单申请被拒绝',
    cancellationMatchedConfirm: '本业务委托号{no}已经与产品委托号{productNo}匹配，现在撤单需要航线人员同意',
    cancellationConfirm: '确定撤销业务委托号{no}吗？',
    cancellationConfirmTitle: '撤单确认',
    applyCancellation: '申请撤单',
    cancelled: '业务委托号{no}已撤单',
    cancellationSent: '{no}撤单申请已发送给对应航线人员',
    cancellationError: '撤单失败',
  },
}
